import { Injectable } from '@angular/core';
import { ListNotifications } from 'src/core/notifications/application/list/list-notifications';
import { GetUnreadNotificationsCount } from 'src/core/notifications/application/unread-count/get-unread-notifications-count';
import { NOTIFICATIONS_PAGE_SIZE } from 'src/core/notifications/domain/notification-repository';

// Refreshes the stored notifications and the unread badge. An open notifications modal is left alone on
// purpose: it only reloads when the user pulls to refresh or opens it again.
@Injectable({
  providedIn: 'any',
})
export class SyncNotifications {
  constructor(
    private readonly listNotifications: ListNotifications,
    private readonly getUnreadNotificationsCount: GetUnreadNotificationsCount
  ) {}

  async execute(): Promise<void> {
    await this.listNotifications.execute(1, NOTIFICATIONS_PAGE_SIZE);
    await this.getUnreadNotificationsCount.execute();
  }
}
